import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { WebSocketService } from "../../services/web-socket.service";
import { HttpClient } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { NgForOf, NgIf } from "@angular/common";
import {MatIconModule} from "@angular/material/icon";
import {UsersService} from "../../admin/users/users.service";

@Component({
  selector: 'app-chat-room',
  templateUrl: './chat-room.component.html',
  styleUrls: ['chat-room.component.scss'],
  standalone: true,
  imports: [FormsModule, NgForOf, NgIf, MatIconModule],
})
export class ChatRoomComponent implements OnInit, OnDestroy {
  @ViewChild('messageContainer') private messageContainer!: ElementRef;

  roomName: string = '1';
  messages: { user: { id: any; username: string; email: string }; message: string; timestamp: string }[] = [];
  newMessage: string = '';
  isTyping = new Set<string>();
  typingTimeout: any;
  socketSub!: Subscription;
  showChatBox:boolean = false;
  userColors:string[] = [
    '#d1eaff', // Soft Sky Blue
    '#ffe5b4', // Soft Peach/Orange
    '#c7f5d9', // Mint Green
    '#dcdcdc', // Lavender
    '#fae9ed', // Soft Rose
  ];
  constructor(private socketService: WebSocketService, private http: HttpClient, private userService: UsersService) {

  }


  ngOnInit(): void {
    this.socketSub = this.socketService.messages$.subscribe((data: any) => {
      if (data.type === 'chat_history') {
        this.messages = data.messages;
        this.scrollToBottom();
      }
      if (data.type === 'chat_message') {
        this.messages.push(data);
        this.scrollToBottom();
      }
      if (data.type === 'typing') {
        this.isTyping.add(data.user.username);
        setTimeout(() => this.isTyping.delete(data.user.username), 2000);
      }
      if (data.type === 'stop_typing') {
        this.isTyping.delete(data.user.username);
      }
    });
  }
  getUserColor(userId) {
    userId = userId.toString()
    // Simple hash: sum char codes and mod by color list length
    let hash = 0;
    for (let i = 0; i < userId.toString().length; i++) {
      hash += userId.charCodeAt(i);
    }
    return this.userColors[hash % this.userColors.length];
  }
  openChatBox() {
    this.showChatBox = true;
    this.socketService.connect(this.roomName);
    setTimeout(() => this.scrollToBottom(), 200); // Optional: scroll down when opened
  }
  closeChatBox() {
    this.showChatBox = false;
  }
  get typingUsers(): string[] {
    return Array.from(this.isTyping);
  }

  loadChatHistory(): void {
    this.http.get(`/api/chat-history/${this.roomName}/`).subscribe((data: any[]) => {
      this.messages = data.reverse(); // Reverse to display oldest first
      this.scrollToBottom();
    });
  }

  sendMessage(): void {
    if (this.newMessage.trim()) {
      this.socketService.send({
        user_id: 30,
        type: 'chat',
        message: this.newMessage,
        user: this.userService.getLoginUserDetails()
      });
      this.newMessage = '';
      this.socketService.send({ type: 'stop_typing' });
    }
  }

  onKeypress(): void {
    clearTimeout(this.typingTimeout);
    this.socketService.send({ type: 'typing' });
    this.typingTimeout = setTimeout(() => {
      this.socketService.send({ type: 'stop_typing' });
    }, 2000);
  }

  scrollToBottom(): void {
    setTimeout(() => {
      if (this.messageContainer) {
        this.messageContainer.nativeElement.scrollTop =
            this.messageContainer.nativeElement.scrollHeight;
      }
    }, 100);
  }

  ngOnDestroy(): void {
    this.socketSub?.unsubscribe();
    this.socketService.disconnect();
  }
}
